module.exports = __webpack_public_path__ + "img/symbol_glaubeliebehoffnung@2x.b9a1e9b.webp";